import { render, staticRenderFns } from "./VIN.vue?vue&type=template&id=b83a5996"
import script from "./VIN.vue?vue&type=script&lang=js"
export * from "./VIN.vue?vue&type=script&lang=js"
import style0 from "./VIN.vue?vue&type=style&index=0&id=b83a5996&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports